if (!customElements.get('poke-galaxy-header')) {
  customElements.define(
    'poke-galaxy-header',
    class PokeGalaxyHeader extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('[data-pg-menu-open]');
        this.dialog = this.querySelector('[data-pg-menu-dialog]');
        this.closeButton = this.querySelector('[data-pg-menu-close]');

        if (!this.trigger || !this.dialog || !this.closeButton) return;

        this.handleOpen = () => this.openMenu();
        this.handleClose = () => this.closeMenu();
        this.handleDialogClose = () => this.afterClose();
        this.handleBackdropClick = (event) => {
          if (event.target === this.dialog) this.closeMenu();
        };

        this.trigger.addEventListener('click', this.handleOpen);
        this.closeButton.addEventListener('click', this.handleClose);
        this.dialog.addEventListener('close', this.handleDialogClose);
        this.dialog.addEventListener('click', this.handleBackdropClick);
      }

      disconnectedCallback() {
        this.trigger?.removeEventListener('click', this.handleOpen);
        this.closeButton?.removeEventListener('click', this.handleClose);
        this.dialog?.removeEventListener('close', this.handleDialogClose);
        this.dialog?.removeEventListener('click', this.handleBackdropClick);
        document.body.classList.remove('pg-menu-open');
      }

      openMenu() {
        if (this.dialog.open) return;
        this.dialog.showModal();
        this.trigger.classList.add('is-open');
        this.trigger.setAttribute('aria-expanded', 'true');
        this.trigger.setAttribute('aria-label', 'Close menu');
        document.body.classList.add('pg-menu-open');
        requestAnimationFrame(() => this.closeButton.focus());
      }

      closeMenu() {
        if (this.dialog.open) this.dialog.close();
      }

      afterClose() {
        this.trigger.classList.remove('is-open');
        this.trigger.setAttribute('aria-expanded', 'false');
        this.trigger.setAttribute('aria-label', 'Open menu');
        document.body.classList.remove('pg-menu-open');
        this.trigger.focus();
      }
    }
  );
}

/* Inline header search: no dialog, backdrop, scroll lock, or focus trap. */
if (!customElements.get('pg-inline-search')) {
  customElements.define('pg-inline-search', class extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.trigger = this.querySelector('summary');
      this.input = this.querySelector('input[type="search"]');
      this.header = this.closest('.pg-site-header');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.details.addEventListener('toggle', () => {
        const open = this.details.open;
        this.header.classList.toggle('pg-search-open', open);
        this.trigger.setAttribute('aria-expanded', String(open));
        this.trigger.setAttribute('aria-label', open ? 'Close search' : 'Search');
        if (open) this.input.focus({ preventScroll: true });
        else this.querySelector('predictive-search')?.close?.();
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.details.open) {
          event.preventDefault();
          event.stopPropagation();
          this.details.open = false;
          this.trigger.focus({ preventScroll: true });
        }
      }, options);
      document.addEventListener('pointerdown', event => {
        if (this.details.open && !this.contains(event.target)) this.details.open = false;
      }, options);
      this.addEventListener('focusout', () => {
        requestAnimationFrame(() => {
          if (!this.contains(document.activeElement)) this.details.open = false;
        });
      }, options);
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.header?.classList.remove('pg-search-open');
    }
  });
}
